export interface AcademicAbsence {
  id: number;
  student_id: number;
  schedule_id: number;
  note: string;
}
